<template lang="pug">
  #app(:class="{pc: getPC(), mobile: !getPC()}")
    .preloader(:class="{ ready }"): img(:src="`${rt}img/loading.gif`")
    #header
      .clearfix(id='header_inner')
        div(id='logo_image')
          h1.logo
            a(href='/beauties/' title='EARTH MALL')
              img(:src="`${rt}img/logo.png`" class='pc_logo_image' style='width:50%; height:auto;' alt='EARTH MALL' title='EARTH MALL')
              img(:src="`${rt}img/logo.png`" class='mobile_logo_image' style='width:50%; height:auto;' alt='EARTH MALL' title='EARTH MALL')
    #main.main: router-view(:rt="rt")
    div(id='footer_bottom')
      .clearfix(id='footer_bottom_inner')
        ul
          li
            a(href='https://www.hakuhodo.co.jp/privacy_policy/' target='_blank') プライバシーポリシー
          li#copyright Copyright ©&nbsp; EARTH MALL
        .active(id='return_top')
          a(href='#body' @click.prevent.stop="onClickTop")
            span PAGE TOP
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      innerWidth: 0,
      ready: false
    }
  },
  mounted () {
    $(window).resize(() => {
      this.innerWidth = window.innerWidth
    }).resize()
    setTimeout(() => {
      this.ready = true
    }, 500)
  },
  methods: {
    createTitle (routeInstance) {
      // タイトルを設定
      if (routeInstance.meta.title) {
        const setTitle = routeInstance.meta.title
        document.title = setTitle
      } else {
        document.title = ''
      }
    },
    onClickTop () {
      $('html, body').animate({ scrollTop: 0 })
    },
    getPC () {
      return this.innerWidth >= 1200
    }
  },
  computed: {
    rt () {
      return this.$router.options.base
    }
  },
  watch: {
    '$route' (routeInstance, from) {
      this.createTitle(routeInstance)
    },
    '$route.path' (next) {
      this.ready = false
      setTimeout(() => {
        this.ready = true
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/reset.scss";
@import "./assets/css/style.css";
@import "./assets/css/child/style.css";
@import "./assets/css/responsive.css";
@import "./assets/css/child/responsive.css";
@import "./assets/css/responsive.css";
h1 {
  padding-top: 8%;

}
@media screen and (min-width:768px) {
  h1 {
    padding-top: 6%;
    img {
      width: 65% !important;
    }
  }
}
#header {
  background-color: transparent;
}
#return_top {
  opacity: 0.25;
  transition: opacity 0.2s ease;
}
.pc #return_top:hover {
  opacity: 1;
  transition: opacity 0.2s ease;
}
.main {
  min-height: 1000px;
}
@media only screen and (max-width: 767px) {
  #footer_bottom ul li:first-child {
    background-color: #c6e1e6;
    color: white;
    a {
      color: white;
    }
  }
}

@media only screen and (max-width: 767px) {
  #footer_bottom ul li:last-child {
    background-color: #b4d6dd;
    color: white;
  }
}

@media only screen and (min-width: 768px) {
  #footer_bottom {
    background-color: #b4d6dd;
    color: white;
    a {
       color: white;
    }
  }
}

html, body {
  background-color: #daebee;
}

#app {
  position: relative;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.preloader {
  width: 100%;
  background-color: white;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 111111;
  img {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  &.ready {
    transition: all 0.6s ease;
    opacity: 0;
    pointer-events: none;
  }
}

#footer_bottom {
  font-family: "Segoe UI", Verdana, "游ゴシック", YuGothic, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
}
</style>
